import React from "react";
import SEO from "../../Components/SEO/SEO";

export default function TeamsPage() {
  return (
    <>
      <SEO
        title="Teams | All Star Xperience Montreal"
        description="Team rosters and standings for All Star Xperience Montreal 7v7 soccer leagues — coming soon."
      />
      <main style={{ padding: "40px 0" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 20px" }}>
          <div style={{
            background: "#111726",
            color: "#e5e7eb",
            border: "1px solid rgba(255,255,255,.08)",
            borderRadius: 18,
            padding: 24
          }}>
            <h2 style={{ margin: 0, fontFamily: "Bebas Neue, system-ui", letterSpacing: ".4px" }}>Teams</h2>
            <p style={{ color: "#94a3b8" }}>Teams listing & rosters coming next.</p>
          </div>
        </div>
      </main>
    </>
  );
}
